import { render, staticRenderFns } from "./myPrize.vue?vue&type=template&id=31e4900c&scoped=true&"
import script from "./myPrize.vue?vue&type=script&lang=js&"
export * from "./myPrize.vue?vue&type=script&lang=js&"
import style0 from "./myPrize.vue?vue&type=style&index=0&id=31e4900c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e4900c",
  null
  
)

export default component.exports